<script async setup lang="ts">
import AccordionComponent from '../accordion/AccordionComponent.vue';
import AccordionTrigger from '../accordion/AccordionTrigger.vue';
import AccordionBody from '../accordion/AccordionBody.vue';

export interface Question {
  question: string;
  answer: string;
}

const faq: Question[] = [
  {
    question: 'Для кого проводятся мероприятия?',
    answer:
      'Для всех, кто желает развиваться: студенты, специалисты, руководители, предприниматели.'
  },
  {
    question: 'Какие будут темы мероприятий?',
    answer:
      'У нас проводятся мероприятия на разные темы: HR, IT, дизайн, маркетинг, продакт и проджект менеджмент, бизнес-аналитика и корпоративное управление. С темами будущих мероприятий можете ознакомиться на нашем сайте в разделе «Предстоящие мероприятия».'
  },
  {
    question: 'Сколько времени длится мероприятие?',
    answer:
      'Все зависит от выбранной темы. В среднем мероприятие длится 2-3 часа.'
  },
  {
    question: 'Как часто будут проводиться мероприятия? ',
    answer:
      'Мероприятия будут проводиться каждый четверг. С актуальной программой можете ознакомиться на нашем сайте. '
  },
  {
    question: 'Сколько стоит участие в мероприятии? ',
    answer:
      'Мы предлагаем бесплатное участие. Чтобы принять участие, зарегистрируйтесь на интересующее вас мероприятие.'
  }
];
</script>

<template>
  <section class="faq">
    <div class="faq-title">
      <h1>Частые вопросы</h1>
    </div>
    <div class="faq-content">
      <AccordionComponent v-for="question in faq" :key="question.question">
        <AccordionTrigger :title="question.question" />
        <AccordionBody>
          <p style="margin-top: 40px">{{ question.answer }}</p>
        </AccordionBody>
      </AccordionComponent>
    </div>
  </section>
</template>

<style scoped lang="scss">
.faq {
  &-title {
    padding: 80px 0 40px;
  }

  &-content {
    gap: 24px;
    display: flex;
    padding: 60px 0;
    flex-direction: column;
  }
}
</style>
